import React from "react";
import {withTranslation} from "react-i18next";
import stylesWelcome from "../SchedaSpecialeMalaria.module.css"
import Calendar from "../../../../../../../components/calendar/Calendar";
import Utils from "../../../../../../../utils/Utils";
import Autocomplete from "../../../../../../../components/autocomplete/Autocomplete";
import Select from "../../../../../../../components/select/Select";
import Input from "../../../../../../../components/textbox/Input";
import OggettiUtili from "../../../../../../../utils/OggettiUtili";


class InfoViaggioMalaria extends React.Component {

    state = {
        infoViaggio: {
            paese: "",
            continente: "",
            dataPartenza: "",
            dataRientro: "",
            motivo: "",
            motivoAltro: "",
            corretto: []
        },
        nazioniPerCodice: JSON.parse(sessionStorage.getItem("nazioniPerCodice")),
        listaNazioni: JSON.parse(sessionStorage.getItem("nazioni"))
    }

    constructor(props) {
        super(props)

        this.riceviValore = this.riceviValore.bind(this);
        this.controlloDati = this.controlloDati.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this)
        this.validate = this.validate.bind(this)

    }

    componentDidMount() {
        let infoViaggio = this.state.infoViaggio
        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.infoViaggioMalaria) {
            let infoViaggioProps = this.props.segnalazioneCopia.schedaSpeciale.infoViaggioMalaria
            infoViaggio.paese = infoViaggioProps.paese ? infoViaggioProps.paese : this.state.infoViaggio.paese
            infoViaggio.continente = infoViaggioProps.continente ? infoViaggioProps.continente : this.state.infoViaggio.continente
            infoViaggio.dataPartenza = infoViaggioProps.dataPartenza ? infoViaggioProps.dataPartenza : this.state.infoViaggio.dataPartenza
            infoViaggio.dataRientro = infoViaggioProps.dataRientro ? infoViaggioProps.dataRientro : this.state.infoViaggio.dataRientro
            infoViaggio.motivo = infoViaggioProps.motivo ? infoViaggioProps.motivo : this.state.infoViaggio.motivo
            infoViaggio.motivoAltro = infoViaggioProps.motivoAltro ? infoViaggioProps.motivoAltro : this.state.infoViaggio.motivoAltro

            this.setState({infoViaggio: infoViaggio});

        } else {
            if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.datiSpecifici && this.props.segnalazioneCopia.datiSpecifici.viaggiESoggiorni) {
                let infoViaggioProps = this.props.segnalazioneCopia.datiSpecifici.viaggiESoggiorni
                infoViaggio.paese = infoViaggioProps.estero ? infoViaggioProps.estero[0].paeseEsteroVisitato ? this.state.nazioniPerCodice[infoViaggioProps.estero[0].paeseEsteroVisitato.codice] : "" : ""
                infoViaggio.dataPartenza = infoViaggioProps.estero ? infoViaggioProps.estero[0].dataDiPartenzaDallItalia ? infoViaggioProps.estero[0].dataDiPartenzaDallItalia : "" : ""
                infoViaggio.dataRientro = infoViaggioProps.estero ? infoViaggioProps.estero[0].dataRientroOArrivoInItalia ? infoViaggioProps.estero[0].dataRientroOArrivoInItalia : "" : ""
                infoViaggio.motivo = infoViaggioProps.estero ? infoViaggioProps.estero[0].motivoDelViaggio ? infoViaggioProps.estero[0].motivoDelViaggio : "" : ""

                this.setState({infoViaggio: infoViaggio});

            }
        }

        this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setInfoViaggioMalaria(this.state.infoViaggio, "", oggetto)

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState !== this.state) {
            let res = this.createOggettoBE()
            this.props.setInfoViaggioMalaria(this.state.infoViaggio, this.validate(), res)
        }
    }

    validate() {

        if (this.state.infoViaggio.dataRientro) {
            let validatedataRientro = Utils.checkDateInterval(this.state.infoViaggio.dataRientro, "31/12/1899");
            let validatedataRientroOdierna = Utils.checkDateInterval(this.state.infoViaggio.dataRientro, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataRientro) {
                return "Messages.DataRientro"
            } else if (!validatedataRientroOdierna) {
                return "Messages.DataRientroOdierna"
            }
        }
        if (this.state.infoViaggio.dataPartenza) {
            let validatedataPartenza = Utils.checkDateInterval(this.state.infoViaggio.dataPartenza, "31/12/1899");
            let validatedataPartenzaOdierna = Utils.checkDateInterval(this.state.infoViaggio.dataPartenza, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataPartenza) {
                return "Messages.DataPartenza"
            } else if (!validatedataPartenzaOdierna) {
                return "Messages.DataPartenzaOdierna"
            }
        }

        return ""

    }

    controlloDati() {
        let infoViaggio = this.state.infoViaggio
        infoViaggio.corretto = []

        if (infoViaggio.paese && infoViaggio.paese.codice && !infoViaggio.motivo) infoViaggio.corretto[0] = "Campo \"Motivo del viaggio\" mancante";
        if (infoViaggio.motivo === "8" && !infoViaggio.motivoAltro) infoViaggio.corretto[1] = "Campo \"Motivo del viaggio - Altro\" mancante";


        this.setState({infoViaggio: infoViaggio})

    }

    createOggettoBE() {
        let infoViaggio = JSON.parse(JSON.stringify(this.state.infoViaggio))
        let infoViaggioBe = Utils.removeEmptyValueFromObject(infoViaggio)
        return Utils.removeFieldFromObject(infoViaggioBe, "corretto")
    }

    riceviValore(field, event) {
        let infoViaggio = this.state.infoViaggio
        if (field.currentTarget) {
            infoViaggio[field.currentTarget.id] = field.currentTarget.value

            if (field.currentTarget.id === "motivo" && field.currentTarget.value !== "8")
                infoViaggio["motivoAltro"] = "";

        } else {
            infoViaggio[field] = event.target.value
        }
        this.setState({infoViaggio: infoViaggio})

        this.controlloDati()

    }

    render() {

        const {t} = this.props;

        const sezione1 = (
            <div>
                <div>
                    <h6>{t("SchedaFlussoSpeciale.Malaria.InfoViaggio.titolo")}</h6>
                    <hr className={stylesWelcome.hr}/>
                </div>
                <div className="container">
                    <div className="row">

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.Malaria.InfoViaggio.paese")}
                            </p>
                            <div className={stylesWelcome.fieldContainer}>
                                <Autocomplete
                                    id={"paese"}
                                    value={this.state.infoViaggio.paese}
                                    keyField={"codice"}
                                    descriptionField={"descrizione"}
                                    suggestionField={"descrizione"}
                                    onChange={this.riceviValore}
                                    field={"paese"}
                                    placeholder={t("SchedaFlussoSpeciale.Malaria.InfoViaggio.paese")}
                                    suggestions={this.state.listaNazioni}
                                >
                                </Autocomplete>
                            </div>
                        </div>

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.Malaria.InfoViaggio.continente")}
                            </p>
                            <Select
                                field={"continente"}
                                value={this.state.infoViaggio.continente}
                                onChange={this.riceviValore}
                                id={"continente"}
                                functionMap={Utils.mapToArray(OggettiUtili.Continenti).map((oggetto) => {
                                    return (
                                        <option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}

                            >
                            </Select>
                        </div>
                    </div>
                </div>
            </div>
        );

        const sezione2 = (

            <div style={{marginTop: "1rem"}}>
                <div className="container">
                    <div className="row">

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.Malaria.InfoViaggio.dataPartenza")}
                            </p>
                            <Calendar
                                id={"dataPartenza"}
                                value={this.state.infoViaggio.dataPartenza}
                                field={"dataPartenza"}
                                onChange={this.riceviValore}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaFlussoSpeciale.Malaria.InfoViaggio.dataPartenza"))}
                                error={(this.state.infoViaggio.dataPartenza === "" || this.state.infoViaggio.dataPartenza == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.infoViaggio.dataPartenza), "-")
                                }
                            >
                            </Calendar>
                        </div>

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.Malaria.InfoViaggio.dataRientro")}
                            </p>
                            <Calendar
                                id={"dataRientro"}
                                value={this.state.infoViaggio.dataRientro}
                                field={"dataRientro"}
                                onChange={this.riceviValore}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaFlussoSpeciale.Malaria.InfoViaggio.dataRientro"))}
                                error={(this.state.infoViaggio.dataRientro === "" || this.state.infoViaggio.dataRientro == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.infoViaggio.dataRientro), "-")
                                }
                            >
                            </Calendar>
                        </div>
                    </div>
                </div>
            </div>

        );

        const sezione3 = (

            <div style={{marginTop: "1rem"}}>
                <div className="container">
                    <div className="row">

                        <div className="col-lg-6">
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.Malaria.InfoViaggio.motivo")}
                                {this.state.infoViaggio.paese && this.state.infoViaggio.paese.codice ?
                                    <span className={stylesWelcome.mandatoryColor}>*</span> : ""}</p>
                            <Select
                                field={"motivo"}
                                value={this.state.infoViaggio.motivo}
                                onChange={this.riceviValore}
                                id={"motivo"}
                                functionMap={Utils.mapToArray(OggettiUtili.MotivoViaggioMalaria).map((oggetto) => {
                                    return (
                                        <option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}

                            >
                            </Select>
                        </div>
                    </div>
                </div>
            </div>
        );

        const sezione4 = (
            <div style={{marginTop: "1rem"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3">
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.Malaria.InfoViaggio.motivoAltro")}
                                <span className={stylesWelcome.mandatoryColor}>*</span></p>
                            <Input id={"motivoAltro"}
                                   onChange={this.riceviValore}
                                   field={"motivoAltro"}
                                   value={this.state.infoViaggio.motivoAltro}
                                   placeholder={t("SchedaFlussoSpeciale.Malaria.InfoViaggio.motivoAltro")}/>
                        </div>
                    </div>
                </div>
            </div>

        );


        return (
            <div>
                {sezione1}
                {sezione2}
                {sezione3}
                {this.state.infoViaggio.motivo === "8" ?
                    sezione4 : (<div/>)
                }

            </div>

        )
    }

}

export default withTranslation('common')(InfoViaggioMalaria)
